import { getUrlParam } from 'common/utils';

import { URL_PARAMS } from '../constants';

export const useURLParamActiveStation = () => {
  return getUrlParam(URL_PARAMS.activeStation);
};
